export const IS_DRAFT =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("bozza") === "1";

// Segnaposto [DA CONFERMARE]: in modalità bozza (?bozza=1) viene evidenziato in giallo,
// altrimenti mostra «—» o scompare (hide).
export const Ph = ({ what = "", hide = false }) => {
    if (IS_DRAFT) {
        return (
            <mark className="ph-mark" data-testid="placeholder-da-confermare">
                [DA CONFERMARE{what ? `: ${what}` : ""}]
            </mark>
        );
    }
    if (hide) return null;
    return <span className="ph-empty">—</span>;
};